import { Dispatch } from 'redux';

import { requestHandler } from '../../api';

export const getSIIBusinessDetails = async (dispatch: any, id: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/business/${id}/sii/details`,
    dispatch,
  });
  if (response) return response.data;
};

export const getBusinessPartners = async (dispatch: any, id: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/business/${id}/sii/partners`,
    dispatch,
  });
  if (response) return response.data;
};

export const getBusinessAddresses = async (dispatch: any, id: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/business/${id}/sii/addresses`,
    dispatch,
  });
  if (response) return response.data;
};

export const getBusinessCreditNotes = async (
  dispatch: any,
  id: string,
  query: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/business/${id}/creditNotes?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getBusinessInvoices = async (
  dispatch: any,
  id: string,
  type: string,
  query: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/business/${id}/invoices?type=${type}&${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getIvaFolderLink = async (dispatch: any, id: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/business/${id}/iva/folder`,
    dispatch,
  });
  if (response) return response.data;
};

export const getIvaCompact = async (dispatch: any, id: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/business/${id}/iva/compact`,
    dispatch,
  });
  if (response) return response.data;
};

export const getAssignatedExecutives = async (dispatch: any, id: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/business/${id}/executives`,
    dispatch,
  });
  if (response) return response.data;
};

export const getBusinessFiles = async (
  dispatch: any,
  businessId: string,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/business/${businessId}/open/files`,
    dispatch,
    data,
    responseType: 'json',
  });
  if (response) return response.data;
};

export const uploadBusinessFile = async (
  dispatch: any,
  businessId: string,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/business/${businessId}/open/files/upload`,
    dispatch,
    data,
    responseType: 'json',
  });
  if (response) return response.data;
};

export const deleteBusinessFile = async (
  dispatch: any,
  businessId: string,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/business/${businessId}/open/files/delete`,
    dispatch,
    data,
    responseType: 'json',
  });
  if (response) return response.data;
};

export const downloadBusinessFile = async (
  dispatch: any,
  businessId: string,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/business/${businessId}/open/files/download`,
    dispatch,
    data,
    responseType: 'json',
  });
  if (response) return response.data;
};

export const createBusinessFolder = async (
  dispatch: any,
  businessId: string,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/business/${businessId}/open/files/createFolder`,
    dispatch,
    data,
    responseType: 'json',
  });
  if (response) return response.data;
};

export const getRelatedBusinesses = async (dispatch: any, id: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/business/${id}/open/relatedBusinesses`,
    dispatch,
  });
  if (response) return response.data;
};

export const getRelatedBusiness = async (
  dispatch: any,
  id: string,
  relatedBusinessIdentifier: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/business/${id}/open/relatedBusinesses/${relatedBusinessIdentifier}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getBusinessOpen = async (dispatch: any, identifier: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/business/${identifier}/open/profile`,
    dispatch,
  });
  if (response) return response.data;
};

export const createBusinessRelation = async (
  dispatch: any,
  identifier: string,
  data: {
    businessToIdentifier: string;
    businessToName: string;
  },
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/business/${identifier}/open/relatedBusinesses`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const deleteRelatedBusiness = async (
  dispatch: any,
  businessFrom: string,
  businessToIdentifier: string,
) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/business/${businessFrom}/open/relatedBusinesses`,
    dispatch,
    data: {
      businessToIdentifier,
    },
  });
  if (response) return response.data;
};

export const getRutificator = async (dispatch: any, ruts: string[]) => {
  const query = ruts.map((rut) => `ruts=${rut}`).join('&');
  const response = await requestHandler({
    method: 'get',
    url: `internal/business/rutificator?${query}`,
    dispatch,
    responseType: 'json',
  });
  if (response) return response.data;
};

export const getStakeholderProfileData = async (
  dispatch: any,
  businessId: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/business/stakeholderProfile/${businessId}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getOperativeProfileData = async (
  dispatch: any,
  businessId: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/business/operativeProfile/${businessId}`,
    dispatch,
  });
  if (response) return response.data;
};

export const createBusinessSimple = async (dispatch: any, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/business/simple`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const getBusinessUnits = async (
  dispatch: Dispatch,
  identifier: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/business/${identifier}/open/units`,
    dispatch,
  });
  if (response) return response.data;
};

export const searchOrCreateBusiness = async (
  dispatch: Dispatch,
  identifier: string,
) => {
  const response = await requestHandler({
    method: 'put',
    url: `internal/business/searchOrCreate/${identifier}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getSigners = async (dispatch: Dispatch, identifier?: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/business/signers${identifier ? `?identifier=${identifier}` : ''}`,
    dispatch,
  });
  if (response) return response.data;
};
